import standardAction from '../../../utilities/standard-action';
import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function showReturnConfirmation(): RootActionTypes {
  return standardAction(ActionTypes.SHOW_RETURN_CONFIRMATION);
}
